import { makeRequest } from 'utils/requestLogger';

export default (id, studentID, skill, dateStart, dateEnd) =>
    makeRequest(
        'get',
        `/api/courses/${id}/get_student_skills/${studentID}?skill=${skill}&dateStart=${dateStart}&dateEnd=${dateEnd}`
    ).then((res) => res.data);


// WEBPACK FOOTER //
// ./src/app/services/courses/getStudentSkills.js